import script from "./TermsUser.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsUser.vue?vue&type=script&setup=true&lang=js"

import "./TermsUser.vue?vue&type=style&index=0&id=694ed4a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-694ed4a2"]])

export default __exports__